import { AsyncPipe } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { User } from "@Front-end/seed/models/user";
import { UserProfileDirective } from "@Front-end/seed/modules/user";
import { PlayerscoreDirective } from "@Front-end/seed/modules/v2/playscore";
import { VipLevelsDirective } from "@Front-end/seed/modules/v2/vip";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { AccountAvatarComponent } from "../../../modules/shared/account-avatar/account-avatar.component";
import { VipProgressBarComponent } from "../../../modules/shared/vip-progress-bar/vip-progress-bar.component";
import { SectionBoxComponent } from "../section-box/section-box.component";

@Component({
    selector: "ls-profile-info",
    templateUrl: "./profile-info.component.html",
    styleUrls: ["./profile-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterModule,
        TranslateModule,
        LocalizeRouterModule,
        VipProgressBarComponent,
        IconComponent,
        PlayerscoreDirective,
        VipLevelsDirective,
        SectionBoxComponent,
        UserProfileDirective,
        AsyncPipe,
        AccountAvatarComponent,
    ],
})
export class ProfileInfoComponent {
    @Input()
    public user: User | null = null;

    @Output()
    public lsCloseRedirect: EventEmitter<string> = new EventEmitter<string>();

    public minioUrl: string = environment.minioUrl;
    protected readonly Array = Array;

    public navigateProfile(): void {
        this.lsCloseRedirect.emit("/profile");
    }

    public navigateVip(): void {
        this.lsCloseRedirect.emit("/vip");
    }
}
